/**
 * Checks the current geolocation permission status
 * @returns Promise<PermissionState> - 'granted', 'denied', or 'prompt'
 */
export async function getGeolocationPermissionStatus(): Promise<PermissionState> {
    if (!navigator.permissions || !navigator.permissions.query) {
        return 'prompt';
    }

    try {
        const status = await navigator.permissions.query({ name: 'geolocation' });
        return status.state;
    } catch {
        return 'prompt';
    }
}
